import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/tmp/8de79e93c510c24/src/modules/core/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/tmp/8de79e93c510c24/src/modules/core/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de79e93c510c24/src/modules/shared/providers/DialogProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de79e93c510c24/src/styles/application.scss");
